import React from 'react'
import { useTranslation } from 'react-i18next'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import "./Services.css";
import ServicesHero from '../../components/pages/Services/ServicesHero/ServicesHero';
import AboutServices from '../../components/pages/About/AboutServices/AboutServices';
import ServicesHowWW from '../../components/pages/Services/ServicesHowWW/ServicesHowWW';
import Partners from '../../components/pages/About/Partners/Partners';
import { usePageContent } from '../../hooks/usePublicQueries';

const unwrapSectionData = (section) => {
  if (section == null) return section;
  if (typeof section === "string") {
    const t = section.trim();
    if (t.startsWith("{")) {
      try {
        const parsed = JSON.parse(t);
        if (parsed && typeof parsed === "object") return unwrapSectionData(parsed);
      } catch {
        return section;
      }
    }
    return section;
  }
  if (typeof section !== "object") return section;
  if (section.data && typeof section.data === "object") return section.data;
  return section;
};

const normalizeSectionSlug = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[_\s-]+/g, "");

const findPageSection = (root, slug) => {
  if (!root || typeof root !== "object") return undefined;
  const target = normalizeSectionSlug(slug);
  const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target);
  return hit != null ? root[hit] : undefined;
};

const Services = () => {
  const { i18n } = useTranslation();
  const { data: pageContent } = usePageContent("services", i18n.language);

  const heroSection =
    findPageSection(pageContent, "hero") ||
    findPageSection(pageContent, "serviceshero") ||
    findPageSection(pageContent, "services");
  const howWeWorkSection =
    findPageSection(pageContent, "howwework") ||
    findPageSection(pageContent, "serviceshowwework");

  return (
    <div className='services-page'>
            <Navbar theme="light" />
            <ServicesHero content={unwrapSectionData(heroSection)} />
            <div className="services-page-content-guide">
            <AboutServices/>
            <ServicesHowWW content={unwrapSectionData(howWeWorkSection)} />
            <Partners/>
            </div>
            <Footer />
        </div>
  )
}

export default Services